<template>
  <a-modal :visible="visible.saveRaw" title="选择原料保存"
    :footer="null"
    @ok="save" 
    @cancel="toggleVisible('saveRaw')"
    :bodyStyle="{padding:'10px'}"
    width="1100px">
    <a-spin :spinning="saveLoading" tip="原料保存中">
    <a-row style="padding:0 0 10px" type="flex" align="middle" justify="space-between">
      <a-col>
        <a-input-search size="small" v-model="filterData.name" @change="inputChange" placeholder="原料名称/代码" style="width: 220px" @search="onSearch" />
      </a-col>
      <base-list-select style="width:400px" v-model="rawType" @change="typeChange" placeholder="选择原料类型" category="raw" />
    </a-row>
    <a-table
      :columns="columns"
      bordered
      :scroll="{y: 280 }"
      :row-selection="{selectedRowKeys, onChange: onSelectChange,type:'radio'}"
      :loading="rawListLoading"
      :data-source="list.records"
      :row-key="record => record.id"
      :pagination="pagination"
      @change="listChange"
    >
      <template slot="name" slot-scope="text,record">
        {{overseasFlag == '1' ? (record.aliasName || text) : text}}
      </template>
    </a-table>
    <a-row type="flex" justify="space-between" class="footer">
      <a-checkbox v-model="coverRawPrice">将配方优化价格保存为原料价格</a-checkbox>
      <a-space class="footer-inner" v-if="coverRawPrice" >
        <a-input :defaultValue="detail.price" v-model="price" placeholder="输入价格">
          <span slot="addonAfter">元/吨</span>
        </a-input>
        <a-radio-group v-model="priceSource" name="radioGroup" :options="priceOptions" />
      </a-space>
      <a-space>
        <a-button @click="toggleVisible('saveRaw')">取消</a-button>
        <a-button @click="confirmSave" type="primary">保存</a-button>
      </a-space>
    </a-row>
  </a-spin>
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils'
import BaseListSelect from '../select/BaseListSelect.vue'

export default {
  mixins:[nhfMixins],
  components:{BaseListSelect},
  watch:{
    'visible.saveRaw'(val){
      if(val){
        const {id} = this.$route.query
        this.formulaId = id
        this.restList()
        this.getList()
      } else {
        this.restList()
      }
    }
  },
  data(){
    return {
      price:null,
      coverRawPrice:false,
      priceSource:"4",
      priceOptions:[
        {label:'市场价格',value:"4"},
        {label:'库存价格',value:"3"},
        {label:'预测价格',value:"2"},
        {label:'合同价格',value:"1"},
      ],
      saveLoading:false,
      rawListLoading:false,
      filterData:{},
      nutLoading:false,
      list:{},
      showFooter:false,
      rawType:[],
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      columns: [
        {
          dataIndex:'name',
          title: '原料名称',
          scopedSlots: {customRender: 'name'},
        },
        {
          dataIndex:'code',
          title: '代码',
        },
        {
          dataIndex:'rawTypeName',
          title: '类型',
        },
        {
          dataIndex:'unit',
          title: '单位',
        },
      ]
    }
  },
  mounted(){
    this.price = this.detail.price
  },
  methods:{
    restList(){
      this.rawType = []
      this.price= this.detail.price
      this.priceSource = "4"
      this.filterData ={}
      this.cleanSelect()
      this.coverRawPrice = false
    },
    inputChange({target}){
      this.getList({
        name:target.value
      })
    },
    confirmSave(){
      if(this.selectedRows.length == 1){
        this.$confirm({
          title: '配方保存为原料',
          content: '保存为原料后，配方营养需要量将覆盖选中原料的营养指标数值，你还要继续吗？',
          cancelText:'取消',
          okText:'确定',
          onOk: ()=> {
            this.save()
          },
          onCancel() {
          },
        });
      } else {
        this.$message.warn(this.selectedRows.length > 0 ? '不能选择多个原料保存' :'请选择要保存的原料')
      }
    },
    listChange(page){
      this.getList({...this.tablePageChange(page)})
    },
    onSearch(name){
      this.getList({
        name
      })
    },
    typeChange(val){
      this.rawType = val
      const typeId = [...val].pop()
      this.filterData.typeId = typeId
      this.getList({
        typeId
      })
    },
    async save(){
      const data = this.selectedRows.map(i=>{
        const {price,priceSource,coverRawPrice} = this
        const {id:privateRawId} = i
        return {
          formulaId:this.formulaId,
          coverRawPrice,
          price:coverRawPrice ? price : null ,
          priceSource:coverRawPrice? priceSource : null ,
          privateRawId,
        }
      })
      await this.fetchPost({
        actions:this.saveCustomFormulaAsRaw,
        loading:'saveLoading',
        data:data[0]
      })
      this.toggleVisible('saveRaw')
      this.$emit('ok')
    },
    async getList(arg = {}){
      const res = await this.fetchGet({
        isList:true,
        loading:'rawListLoading',
        name:'list',
        actions:this.myCustomerRawPage,
        data:{
          ...this.filterData,
          factoryId:this.factoryId,
          customId: this.detail.customId,
          // formulaId:this.formulaId,
          size:20,
          ...arg,
        }
      })
      if(res && res.data && res.data.records){
        this.cleanSelect()
        this.cacheData = JSON.parse(JSON.stringify(res.data.records))
      }
      return res
    }
  }

}
</script>

<style lang="scss" scoped>
  .footer{
    padding:15px 5px;
    &-inner{
      flex:1;
    }
    ::v-deep .ant-input-group-addon{
      font-size: 12px;
    }
  }
</style>